import { useEffect, useState } from "react";
import { navItems } from "@/mocks/civicData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <a
          href="#home"
          className="flex items-center gap-2.5 text-foreground-950"
          aria-label="回到首页"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-sun-line text-xl" />
          </span>
          <span className="font-heading text-lg font-bold tracking-wide md:text-xl">
            朝阳群众<span className="text-primary-500">·</span>线索指南
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 whitespace-nowrap transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#channels"
          className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-block"
        >
          立即反映
        </a>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <ul className="space-y-1 px-4 py-3">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#channels"
                onClick={() => setOpen(false)}
                className="mt-2 block rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
              >
                立即反映
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}